import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { userUpdate } from "../../graphql";
import { CURRENT_USER_QUERY, useAuthContext } from "../auth";
import { useMutation } from "@apollo/client";
import { getOutlookAccessToken } from "../../services/emailService";

const OutlookConfig = () => {
  const { user } = useAuthContext();
  const [isConfigured, setIsConfigured] = useState(false);
  const [UpdateUser, { loading, data }] = useMutation(userUpdate, {
    refetchQueries: [
      {
        query: CURRENT_USER_QUERY,
      },
    ],
  });

  const get_sms_access_token = localStorage.getItem("ring_central_token");
  const get_sms_refresh_token = localStorage.getItem("ring_central_refresh_token");

  useEffect(() => {
    if (!loading && data) {
      window.location.reload();
    }
  }, [loading, data]);

  useEffect(() => {
    const outlookAccessToken = localStorage.getItem("outlook_token");
    setIsConfigured(!!outlookAccessToken);
  }, []);

  const handleOutlookLogin = () => {
    const clientId = process.env.REACT_APP_OUTLOOK_CLIENT_ID;
    const redirectUri = `${window.location.origin}/auth/callback`;
    const scope = "https://graph.microsoft.com/Mail.Send";
    
    const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&response_mode=query`;
    
    window.location.href = authUrl;
  };

  const handleSuccess = async (code) => {
    try {
      // Use the new email service function
      getOutlookAccessToken(code);

      // Wait a bit for the token to be stored
      setTimeout(async () => {
        const outlookAccessToken = localStorage.getItem("outlook_token");
        const outlookRefreshToken = localStorage.getItem("outlook_refresh_token");
        const outlookUserData = localStorage.getItem("outlook_user_data");

        if (outlookAccessToken) {
          localStorage.removeItem("gmail_token");
          localStorage.removeItem("gmail_refresh_token");
          localStorage.removeItem("gmail_user_data");

          UpdateUser({
            variables: {
              data: {
                id: user.id,
                access_token_data: {
                  google_access_token: "",
                  google_refresh_token: "",
                  outlook_access_token: outlookAccessToken,
                  outlook_refresh_token: outlookRefreshToken || "",
                  sms_access_token: get_sms_access_token || "",
                  sms_refresh_token: get_sms_refresh_token || "",
                  mailchimp_user_field_mapping:
                    user.access_token_data?.mailchimp_user_field_mapping || "",
                },
              },
            },
          });
        }
      }, 1000);
    } catch (error) {
      console.error("Error exchanging authorization code for tokens:", error);
    }
  };

  // Check if we're returning from Outlook OAuth
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');
    
    if (code && !error) {
      handleSuccess(code);
    }
  }, []);

  return (
    <Button variant="contained" onClick={handleOutlookLogin}>
      {isConfigured ? "Reconfigure Outlook" : "Connect Outlook"}
    </Button>
  );
};

export default OutlookConfig;
